import Store from 'store/store';
import pendingPromise from 'utils/pendingPromise';

let currentLocationRequest = 0;
const EMPTY_GEO = {
	city: null,
	countryCode: null,
	countryName: null,
	lat: null,
	loading: null,
	lon: null,
	region: null,
	state: null
};

Store.on('SET_USER_LOCATION', async (location, source, ticketType) => {
	let geo = Store.get().client.geo;
	let promise = geo.loading;
	if (!promise) {
		promise = pendingPromise();
		geo.set({ loading: promise }).now();
	}
	let requestId = ++currentLocationRequest;
	try {
		location = await (typeof location === 'function' ? location() : location);
	} catch (e) {
		// Error while getting location
		console.log('Error while getting location', e);
	}

	if (requestId !== currentLocationRequest) {
		return;
	}
	let storeGeo = Store.get().client.geo.set({ loading: null });
	if (!location || !location.lat || !location.lon) {
		return promise.resolve();
	}

	// Ensure EMPTY_GEO keys are present in the new location object
	const newValue = { ...EMPTY_GEO, ...location };
	if (!newValue.city && newValue.label) {
		newValue.city = newValue.label;
	}
	if (!newValue.countryCode && newValue.country) {
		newValue.countryCode = newValue.country;
		delete newValue.country;
	}

	// Note: this only replaces the values in the new location object. We should clear the previous fields here as well
	//  (either by using .reset or by making sure the newValue contains all the keys we want - with undefined if they're not in the location object)
	storeGeo.set(newValue).now();
	Store.emit('USER_LOCATION_UPDATED', { geo: newValue, source, ticketType });
	promise.resolve(newValue);
});
